/** Payroll permission string constants (codegen target: permissions.yaml). */
export const PayrollPermissions = {
  manage: 'manage_payroll',
  /** Supervisor field attendance capture (mobile + supervisor desk). */
  approveAttendance: 'approve_attendance',
  employeeSetup: 'payroll_manage_employee_setup',
  payPeriod: 'payroll_manage_pay_period',
  /** Accounts monthly-close workspace (create/operate draft runs + notes). */
  accountsWorkspace: 'payroll_accounts_workspace',
  /** Correct daily attendance marks (HR); Accounts does not receive this. */
  attendanceCorrect: 'payroll_attendance_correct',
  identityManage: 'payroll_identity_manage',
  adminDashboardRead: 'payroll_admin_dashboard_read',
  exportAttendanceCalendar: 'payroll_export_attendance_calendar',
  exportAttendanceCalculation: 'payroll_export_attendance_calculation',
  exportSalaryCalculation: 'payroll_export_salary_calculation',
  exportStaffCost: 'payroll_export_staff_cost',
  exportBilling: 'payroll_export_billing',
  exportPaymentDetails: 'payroll_export_payment_details',
  /** Team attendance (self-serve supervisor or HR peek). */
  teamAttendanceAccess: ['approve_attendance', 'manage_payroll'] as const,
  /**
   * Admin console, dashboard, staff roster.
   * Requires a real admin/ops cap — not bare manage_payroll (Accounts has that alone).
   */
  adminConsoleAccess: [
    'payroll_admin_dashboard_read',
    'payroll_identity_manage',
    'payroll_manage_pay_period',
  ] as const,
  /** Identity board, assignments, staff card. */
  identityAccess: ['manage_payroll', 'payroll_identity_manage'] as const,
  /** Pay run list, create wizard, and period board. */
  payRunAccess: [
    'manage_payroll',
    'payroll_manage_pay_period',
    'payroll_accounts_workspace',
  ] as const,
  /** Accounts monthly-close dashboard + operate (hold/adjust/second run). */
  accountsWorkspaceAccess: [
    'payroll_accounts_workspace',
    'payroll_manage_pay_period',
  ] as const,
  /** Catch-up settlements inbox + schedule / salary2 capture. */
  settlementManage: 'payroll_settlement_manage',
  settlementRequest: 'payroll_settlement_request',
  settlementApprove: 'payroll_settlement_approve',
  settlementRecoveryApprove: 'payroll_settlement_recovery_approve',
  supplementalRunManage: 'payroll_supplemental_run_manage',
  settlementAccess: [
    'manage_payroll',
    'payroll_settlement_manage',
    'payroll_settlement_request',
    'payroll_settlement_approve',
    'payroll_settlement_recovery_approve',
    'payroll_manage_pay_period',
  ] as const,
  /** Workforce deployment console — assignment + supervisor scope. */
  workforceDeploy: ['payroll_identity_manage', 'payroll_manage_employee_setup'] as const,
  /** Configure which staff-document fields each supervisor may see. */
  supervisorStaffDocumentsManage: 'supervisor_staff_documents_manage',
  /** Supervisor portal for in-house AM Global staff documents. */
  supervisorStaffDocumentsRead: 'supervisor_staff_documents_read',
  supervisorStaffDocumentsAccess: [
    'supervisor_staff_documents_read',
    'supervisor_staff_documents_manage',
  ] as const,
} as const
